import { render, staticRenderFns } from "./PxCriterioFilial.vue?vue&type=template&id=3f81caad&"
import script from "./PxCriterioFilial.vue?vue&type=script&lang=js&"
export * from "./PxCriterioFilial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports